import React from 'react'

import Header from './sections/Header'
import Page from '../../../../components/pdf/Page'

import CoverSection from './sections/00.CoverSection'
import CorrectiveActionsSection from './sections/01.CorrectiveActionsSection'

const PdfDocument = ({ serviceOrder }) => {
  return (
    <Page header={<Header />}>
      <CoverSection serviceOrder={serviceOrder} />
      <CorrectiveActionsSection serviceOrder={serviceOrder} />
    </Page>
  )
}

export default PdfDocument
